import React from "react";

import { formatDateOnly } from "../../../../utils/datetime";
import { formatLanguages } from "../../../../constants/languages";
import {
  CardAction,
  Field,
  FieldGrid,
  OverviewCard,
  UserIcon,
} from "./overviewUi";

/**
 * "Profil & Kontakt" — the tenant's master data, read-only.
 *
 * Deliberate omissions (O1a product decision, not oversights):
 *   - IBAN: stays in the model, the API and the edit form; it is simply not a
 *     thing anyone scans a tenant overview for.
 *   - "Schweizer/in": Nationalität already answers it, and stating the same
 *     fact twice in one card is the redundancy this redesign removes.
 *   - Firma: rendered ONLY when it holds a value. A prominent "Firma —" is a
 *     row that costs attention and carries nothing.
 *
 * `Aufenthaltsbewilligung` keeps its own cell even when empty so the four-column
 * grid does not reflow between tenants.
 */
export default function ProfileContactCard({ tenant, permitLabel, onEdit }) {
  const company = String(tenant?.company || "").trim();

  return (
    <OverviewCard
      title="Profil & Kontakt"
      icon={<UserIcon />}
      accent="blue"
      testId="overview-profile-card"
      action={
        onEdit ? (
          <CardAction onClick={onEdit} testId="overview-profile-edit">
            Bearbeiten
          </CardAction>
        ) : null
      }
    >
      <FieldGrid>
        <Field label="Vorname" value={tenant?.first_name} />
        <Field label="Nachname" value={tenant?.last_name} />
        <Field
          label="Geburtsdatum"
          value={tenant?.birth_date ? formatDateOnly(tenant.birth_date) : null}
        />
        <Field label="Nationalität" value={tenant?.nationality} />
        <Field label="E-Mail" value={tenant?.email} />
        <Field label="Telefon" value={tenant?.phone} />
        <Field label="Sprache" value={formatLanguages(tenant?.languages)} />
        <Field label="Aufenthaltsbewilligung" value={permitLabel} />
        {company ? <Field label="Firma" value={company} /> : null}
      </FieldGrid>
    </OverviewCard>
  );
}
